export default class UrlUtil {

  static getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  static getHref() {
    return window.location.href;
  }

  static getPath() {
    return window.location.pathname;
  }

  static getSearch() {
    return window.location.search;
  }

  static addUrlParameterToHref(parameterName, parameterValue) {
    let href = UrlUtil.getHref();
    let params = `${parameterName}=${encodeURIComponent(parameterValue)}`;
    if (href.indexOf('?') > -1) {
      return href + '&' + params;
    } else {
      return href + '?' + params;
    }
  };

  //https://stackoverflow.com/questions/5999118/how-can-i-add-or-update-a-query-string-parameter
  static updateQueryStringParameter(uri, key, value) {
    let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    let separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + encodeURIComponent(value) + '$2');
    }
    else {
      return uri + separator + key + "=" + encodeURIComponent(value);
    }
  }

  static replaceOrAddUrlParameterToHref(parameterName, parameterValue) {
    return UrlUtil.updateQueryStringParameter(UrlUtil.getHref(), parameterName, parameterValue);
  };

}